import { animate_children, bigScreen_animate_children, app_animate_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxAnimate = {
  name: "cxAnimate",
  desc: "动画装饰",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "动画",
        children: app_animate_children
      }
    ],
    bigScreen: [
      {
        name: "动画",
        children: bigScreen_animate_children,
        group: "element",
        sort: 70
      }
    ],
    portal: [
      {
        name: "动画",
        children: animate_children
      }
    ]
  },
  toolbars: [
    {
      name: "cxAnimate",
      label: "动画",
      comp: {
        animateComponentData: () => import("./toolbars/animate-options-data.vue"),
        animateComponentSetting: () => import("./toolbars/animate-options-setting.vue"),
        animateComponentStyle: () => import("./toolbars/animate-options-style.vue")
      }
    }
  ]
}

export default cxAnimate
